
/**
 * Row布局
 * wzhe
 */
var SgiQuoteEO = function () {
    return ({
        desId: "EP_EO_UI_4005",
        type: 'copy',
        isInRoot: 'yes',
        quoteUID: '',
        ctlN: "引用组件"
    })
};
export { SgiQuoteEO };
export default SgiQuoteEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiQuoteEO.js